export default Object.freeze([
  'Работает',
  'Школьник',
  'Студент',
  'Пенсионер',
  'Инвалид',
  'Безработный',
  'Переселенец',
  'Мигрант',
])
